import React from 'react';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import InovxLoader from '@shared/global/InovxLoader';

interface OperationProgressDialogProps {
    visible: boolean;
    message?: string;
}

const OperationProgressDialog: React.FC<OperationProgressDialogProps> = ({ visible, message }) => {
    if (!visible) {
        return null;
    }

    return (
        <DialogComponent
            target={'#app'}
            width='360px'
            visible={true}
            isModal={true}
            showCloseIcon={false}
            closeOnEscape={false}
            allowDragging={false}
            cssClass="operation-progress-dialog"
            zIndex={120000}
            animationSettings={{ effect: 'None' }}
        >
            <div className="operation-progress-content" role="status" aria-live="polite" aria-busy="true">
                <div className="operation-progress-spinner" aria-hidden="true"></div>
                <div className="operation-progress-message">{message || InovxLoader.t('common:progress.operationInProgress')}</div>
                <div className="operation-progress-caption">{InovxLoader.t('common:progress.pleaseWait')}</div>
            </div>
        </DialogComponent>
    );
};

export default OperationProgressDialog;